var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 44.8275L18.211 55.4989L24.5006 44.5804L30.7901 55.5L36.4503 44.8287L48.5 45.2511L39.0622 28.8655L40.4756 28.2357L39.945 23.1375L42.9455 18.9878L39.945 14.8382L40.4767 9.73993L35.805 7.65713L33.727 2.97453L28.6406 3.50634L24.5006 0.5L20.3605 3.50747L15.2741 2.97453L13.1962 7.65713L8.52443 9.73993L9.05499 14.8382L6.05563 18.9878L9.05613 23.1375L8.52443 28.2357L9.9389 28.8666L0.5 45.25L12.5508 44.8275ZM36.9752 29.797L44.4827 42.8313L35.1097 42.5022L30.7072 50.8026L25.8117 42.3029L30.2278 34.6356L31.3128 34.7495L33.7259 35.0023L35.8038 30.3185L36.9752 29.797ZM10.9557 26.8259L11.4056 22.5066L8.86185 18.9878L11.4056 15.469L10.9557 11.1497L14.9174 9.38236L16.6806 5.41149L20.99 5.86244L24.5006 3.31275L28.0112 5.86244L32.3205 5.41149L34.0838 9.38236L38.0454 11.1497L37.5955 15.469L40.1393 18.9878L37.5955 22.5066L38.0454 26.8259L37.9204 26.8817L34.0838 28.5933L32.3205 32.5642L28.0112 32.1132L24.5006 34.6629L20.99 32.1132L16.6806 32.5642L14.9174 28.5933L11.0807 26.8817L10.9557 26.8259ZM15.2741 35.0011L20.3605 34.4693L24.5006 37.4757L27.0262 35.6411L23.1895 42.3029L18.2939 50.8026L13.8915 42.5022L4.5196 42.8313L12.0271 29.797L13.1973 30.3185L15.2741 35.0011Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 55,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.3cd997811867dc72452eae09b27dd2b5.svg";
export { ForwardRef as ReactComponent };